<template>
	<div class="view">
		<div
			class="article"
			:class="[{soon: article.soon}, article.id]"
			v-for="article in articles"
			:key="article.id"
			@mouseover="selectArticle(article)"
			@mouseout="selected = null"
			@click="onClick(article)"
		>
			<div class="bg">
				<div class="bg-mask"></div>
			</div>

			<div style="z-index: 5" v-if="article.soon">
				<div class="title">Скоро</div>
			</div>

			<div class="article-inner" style="z-index: 5" v-else>
				<div>
					<div class="title">{{ article.title }}</div>
					<div class="text" v-html="article.text"></div>
				</div>

				<router-link :to="article.link">
					<uiButton :color="selected === article.id ? 'dark' : 'light'">Читать</uiButton>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Articles',
	data() {
		return {
			selected: null,
			articles: [
				{
					id: 'one',
					title: 'Тату-культура',
					text: 'Что чаще бьют в России, а что — на Западе? Источники вдохновения и то, что нужно знать, если решились на первую тату.',
					link: '/tatu-culture'
				},
				{
					id: 'two',
					title: 'ЛИЧНЫЙ ОПЫТ',
					text: 'Принципы и табу.<br>Стоит ли делать татуировку?',
					link: '/lichni-opit',
				},
				{
					id: 'three',
					title: 'ТРЕНДЫ В ИНДУСТРИИ',
					text: 'Новая волна популярности татуировок. Кто что хочет набить и сколько это стоит.',
					link: '/trendi-v-industrii',
				}
			]
		}
	},
	methods: {
		selectArticle(article) {
			if (window.innerWidth < 900) return
			if (article.soon) return this.selected = null
			this.selected = article.id
		},
		onClick(article) {
			if (!article.link) return
			ga('send', 'event', 'article-open', article.title)
			this.$router.push(article.link)
		}
	}
}
</script>

<style lang="less" scoped>
@import "../styles.less";

.view {
	display: flex;
}

.article {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 1;
	height: 100vh;
	position: relative;
	cursor: pointer;

	.bg {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 0;
		background-size: cover;

		.bg-mask {
			width: 100%;
			height: 100%;
			position: absolute;
			background: @color-main;
			opacity: 0;
			transition: all 300ms ease;
		}
	}

	&:hover {
		.bg .bg-mask {
			opacity: 0.9;
		}

		.text,
		.title {
			color: #000;
		}
	}

	&.soon:hover {
		cursor: default;

		.bg .bg-mask {
			opacity: 0;
		}

		.text,
		.title {
			color: #fff;
		}
	}
}

.article.one .bg {
	background-image: url("../assets/photos/article1.jpg");
}
.article.two .bg {
	background-image: url("../assets/photos/article2.jpg");
}
.article.three .bg {
	background-image: url("../assets/photos/article3.jpg");
}

.title {
	font-size: 32px;
	font-weight: bold;
	margin-top: 60px;
	margin-bottom: 30px;
	text-transform: uppercase;
	font-family: @font-title;
	transition: all 300ms ease;
}

.text {
	font-size: 18px;
	max-width: 480px;
	line-height: 30px;
	transition: all 300ms ease;
	margin-bottom: 30px;
	min-height: 100px;
}

@media (max-width: 900px) {
	.view {
		flex-direction: column;
	}

	.article {
		height: 70vh;
	}
	.article.one .bg {
		background-image: url("../assets/photos/article1.jpg");
		background-position: center 70%;
	}

	.article-inner {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		padding-bottom: 10vh;
	}

	.title {
		margin-top: 0px;
		margin-bottom: 10px;
	}

	.text {
		font-size: 16px;
		min-height: 0px;
		max-width: 80%;
		margin: 0 auto;
		margin-bottom: 20px;
		line-height: 20px;
	}
}
</style>
